import React from 'react';

interface Props {
  seconds: any;
}

export default function ArticleAudioTime({ seconds }: Props) {
  let minutes: any = Math.floor(seconds / 60);
  let remainingSec: any = Math.floor(seconds % 60);

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (remainingSec < 10) {
    remainingSec = `0${remainingSec}`;
  }

  const formattedTime = `${minutes}:${remainingSec}`;
  return <p style={styles.time}>{formattedTime}</p>;
}

const styles = {
  time: {
    fontSize: 12
  }
};
